<template>
  <div class="hot-products container">
    <h2 @click="$router.pushToTab(data.value.title.value.link.url)">{{ data.value.title.value.text }}</h2>
    <div class="product-wrap">
      <div v-for="(item, index) in data.value.goodsList.value.list" :key="index" class="product" @click="goSku(item.sku_id)">
        <div class="image-container">
          <img :src="$img(item.sku_image)" @error="imageError(index)" alt="商品1">
        </div>
        <p class="product-name">{{ item.goods_name }}</p>
        <p class="product-price">{{ item.discount_price }}元</p>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/utils/config"
import { mapGetters } from 'vuex';
export default {
  name: 'memner-info',
  props: {
    data: {
      type: Object
    }
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
    goSku(skuId) {
      this.$router.pushToTab('/sku-' + skuId);
    },
  }

};
</script>

<style lang="scss">
.hot-products {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 0;
  background-color: #ffffff;
  margin: 20px 0;
  border-radius: 8px;
}

.hot-products h2 {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.product-wrap {
  width: 100%;
  display: flex;
}

.product {
  flex: 0 0 calc(20% - 20px);
  // width: calc(20% - 20px); /* 每行5个商品 */
  margin-bottom: 20px;
  text-align: center;
  // background-color: #f5f5f5; /* 淡灰色背景 */
  padding: 10px;
  border-radius: 8px;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.product:hover {
  transform: scale(1.05);
}

.image-container {
  width: 100%;
  height: 200px;
  /* 固定高度 */
  overflow: hidden;
  border-radius: 8px;
  background-color: #f5f5f5;
  /* 图片容器背景色 */
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* 保持比例，以最长边显示全 */
}

.product-name {
  width: 100%;
  margin: 10px 0 4px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 限制两行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-price {
  font-size: 16px;
  font-weight: 700;
  color: $base-color;
}
</style>
